import React from 'react';
import { Card, Typography } from 'antd';
import { DollarOutlined } from '@ant-design/icons';
import TechRateSettings from '../../components/Money/TechRateSettings';

const { Title, Text } = Typography;

/**
 * Owner settings page for tech labor cost rates.
 * Mounted at /owner/settings/tech-rates — owner-gated by parent route.
 */
const TechRateSettingsPage: React.FC = () => (
  <div style={{ padding: '16px 12px', maxWidth: 800 }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4 }}>
      <DollarOutlined style={{ fontSize: 20, color: '#2563eb' }} />
      <Title level={3} style={{ margin: 0 }}>Tech Labor Cost Rates</Title>
    </div>
    <Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>
      Set the hourly cost for each technician. Used to calculate job profit.
      Owner-only — staff cannot see these rates.
    </Text>
    <Card size="small">
      <TechRateSettings />
    </Card>
  </div>
);

export default TechRateSettingsPage;
